(() => {
  if (customElements.get('senza-finishes')) return;
  class SenzaFinishes extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.choices = new Map();
      this.selectable = !!this.closest('senza-chair-design');
      this.dialog = this.querySelector('dialog');
      if (this.selectable) this.querySelectorAll('.sz-finish-card').forEach((card,index) => {
        card.setAttribute('aria-pressed','false');card.removeAttribute('aria-haspopup');card.removeAttribute('aria-controls');card.setAttribute('aria-label','Elegir '+card.dataset.kind+' '+card.dataset.title);
        if(card.parentElement.classList.contains('sz-sample-tile'))return;
        const tile=document.createElement('div');tile.className='sz-sample-tile';
        const zoom=document.createElement('button');zoom.type='button';zoom.className='sz-sample-zoom';zoom.dataset.previewFinish=index;zoom.textContent='Ampliar';zoom.setAttribute('aria-label','Ampliar '+card.dataset.title);zoom.setAttribute('aria-haspopup','dialog');
        card.before(tile);tile.append(card,zoom);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-preview-finish')) {
          this.trigger=this.querySelectorAll('.sz-finish-card')[Number(button.dataset.previewFinish)];this.returnFocus=button;this.showSheet=false;this.openDetail();
        }
        if (button.hasAttribute('data-finish')) {
          if(this.selectable && !button.hasAttribute('data-full-sheet')){this.toggleChoice(button);return;}
          this.trigger = button;
          this.showSheet = button.hasAttribute('data-full-sheet');
          this.returnFocus=button;this.openDetail();
        }
        if (button.hasAttribute('data-select-finish') && this.trigger && !this.trigger.hasAttribute('data-full-sheet')) {this.setChoice(this.trigger);this.renderDetail();}
        if (button.hasAttribute('data-remove-finish-sample')) {this.toggleChoice(this.trigger);this.renderDetail();}
        if (button.hasAttribute('data-close')) this.dialog.close();
        if (button.hasAttribute('data-toggle-sheet')) {
          this.showSheet = !this.showSheet;
          this.renderDetail();
          this.dialog.scrollTop = 0;
        }
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }), { signal });
    }
    openDetail(){this.querySelector('[data-dialog-title]').textContent=this.trigger.dataset.kind+' · '+this.trigger.dataset.title;this.renderDetail();this.dialog.showModal();this.dialog.scrollTop=0;}
    choiceId(button){return button.dataset.kind+' · '+button.dataset.title;}
    emitChoice(){this.dispatchEvent(new CustomEvent('sz-design-choice',{bubbles:true,detail:{type:'finish',items:[...this.choices.values()]}}));}
    setChoices(items=[]){this.choices=new Map(items.map(s=>[s.id,s]));this.paintChoice();}
    setChoice(button){const id=this.choiceId(button);this.choices.set(id,{id,label:id});this.paintChoice();this.emitChoice();}
    toggleChoice(button){const id=this.choiceId(button);if(this.choices.has(id)){this.choices.delete(id);this.paintChoice();this.emitChoice();}else this.setChoice(button);}
    paintChoice(){this.querySelectorAll('.sz-finish-card').forEach(card=>{const selected=this.choices.has(this.choiceId(card));card.classList.toggle('is-selected',selected);if(this.selectable){card.setAttribute('aria-pressed',String(selected));card.setAttribute('aria-label',(selected?'Quitar ':'Elegir ')+card.dataset.kind+' '+card.dataset.title);}});}
    renderDetail() {
      const crop = this.trigger.querySelector('.sz-fabric-crop');
      const select = this.querySelector('[data-select-finish]');
      if (select) {
        select.hidden = !crop;
        const selected=this.trigger.classList.contains('is-selected');
        select.textContent = selected ? 'Terminación elegida' : 'Elegir esta terminación';select.disabled=selected;
        this.querySelector('[data-remove-finish-sample]').hidden=!crop||!selected;
      }
      const area = this.querySelector('[data-detail]');
      if (this.showSheet || !crop) {
        const img = document.createElement('img');
        img.src = this.trigger.dataset.source;
        img.alt = 'Muestrario completo de ' + this.trigger.dataset.kind + ': ' + this.trigger.dataset.title;
        img.className = 'sz-fabric-sheet';
        area.replaceChildren(img);
      } else {
        area.replaceChildren(crop.cloneNode(true));
      }
      const toggle = this.querySelector('[data-toggle-sheet]');
      toggle.hidden = !crop;
      toggle.textContent = this.showSheet ? 'Volver a la terminación' : 'Ver muestrario completo';
    }
    resetChoice() {
      this.setChoices();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
    }
  }
  customElements.define('senza-finishes', SenzaFinishes);
})();
